import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import { chat, currentUser, markets, snapshots } from '../ducks';

const allReducers = combineReducers({
  chat,
  currentUser,
  form,
  markets,
  snapshots,
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js